import db from '@/rxdb/database';
import { map } from 'rxjs';
import { getCachedObservable } from '@/rxdb/observablesCache';
import { getAPIHeaders } from '@/services/api.service';
import { notyf } from '@/features/toasts/toats.service';

function mapContractualDocument(item) {
    return item
        ? {
              ...item.toMutableJSON(),
              emissionDueDate: item.emissionDueDate ? new Date(item.emissionDueDate) : null,
              emissionDate: item.emissionDate ? new Date(item.emissionDate) : null,
          }
        : null;
}

export function getContractualDocuments(projectId) {
    return getCachedObservable('getContractualDocuments_' + projectId, () =>
        db
            .getProjectCollections(projectId)
            .contractualDocuments.find()
            .$.pipe(map((contractualDocuments) => contractualDocuments.map(mapContractualDocument))),
    );
}
export function removeContractualDocument(projectId, id) {
    return db
        .getProjectCollections(projectId)
        .contractualDocuments.findOne({ selector: { id: id } })
        .remove();
}

export async function createContractualDocument(projectId, item) {
    const result = await db.getProjectCollections(projectId).contractualDocuments.insert({
        signers: [],
        attachments: [],
        predecessors: [],
        ...item,
    });
    return result.toJSON();
}

export async function updateContractualDocument(projectId, contractualDocument) {
    const dbContractualDocument = await db
        .getProjectCollections(projectId)
        .contractualDocuments.findOne({ selector: { id: contractualDocument.id } })
        .exec();
    const patch = { ...JSON.parse(JSON.stringify(contractualDocument)) };
    if (contractualDocument.emissionDate === null || !!contractualDocument.emissionDate) {
        patch.emissionDate = contractualDocument.emissionDate ? contractualDocument.emissionDate.toISOString() : null;
    }
    if (contractualDocument.emissionDueDate === null || !!contractualDocument.emissionDueDate) {
        patch.emissionDueDate = contractualDocument.emissionDueDate
            ? contractualDocument.emissionDueDate.toISOString()
            : null;
    }
    return dbContractualDocument.atomicPatch(patch);
}

export function getContractualDocument(projectId, contractualDocumentId) {
    return db
        .getProjectCollections(projectId)
        .contractualDocuments.findOne({ selector: { id: contractualDocumentId } })
        .$.pipe(map(mapContractualDocument));
}

export async function inviteToSign(projectId, contractualDocumentId) {
    let response = await fetch(`/api/projects/${projectId}/contractualDocuments/${contractualDocumentId}/invites`, {
        method: 'POST',
        headers: getAPIHeaders(),
    });
    if (response && response.ok) {
        notyf.success('Invitations envoyées');
    } else {
        notyf.error('Error avec les invitations');
        throw new Error('inviteToSign failed');
    }
}
export async function getSignatures(projectId, contractualDocumentId) {
    let response = await fetch(`/api/projects/${projectId}/contractualDocuments/${contractualDocumentId}/signatures`, {
        headers: getAPIHeaders(),
    });
    if (response && response.ok) {
        return response.json();
    } else {
        notyf.error(`Error avec l'état des signature`);
        throw new Error('getSignatures failed');
    }
}

export default {
    updateContractualDocument,
};
